/**
 * Helpers partagés — volet « Entreprise » (Batch #14.243 / #14.314).
 * Les tuiles Revenus · Dépenses · Kilométrage ne sont plus dans Tenue de livres : les pièces reçues du portail
 * se traitent dans Files PMS › Entreprise (ENT_INBOX_REDIRECT garde les anciens liens vivants).
 */
import { useEffect, useState } from "react";
import { LayoutDashboard, Percent } from "lucide-react";
import { API, authH } from "@/api";
import { fmtCAD, today } from "@/lib/format";
export { API, authH, fmtCAD, today };

export const ENT_TILES = [
  { id: "apercu", title: "Aperçu entreprise", desc: "Revenus · Dépenses · Résultat (grand livre) · réglages Entreprise & taxes", icon: LayoutDashboard, tone: "teal" },
  { id: "taxes", title: "TPS / TVQ", desc: "Par période de déclaration (ventes & achats reportés)", icon: Percent, tone: "indigo" },
];
export const ENT_TILE_IDS = ENT_TILES.map((t) => t.id);
export const ENT_INBOX_REDIRECT = { revenus: "ent_revenues", depenses: "ent_expenses", kilometrage: "ent_mileage" };

export const inputCls = "w-full border border-slate-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-300";
export const YEARS = [0, -1, -2, -3].map((d) => new Date().getFullYear() + d);
export const MONTHS_FR = ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Août", "Sep", "Oct", "Nov", "Déc"];

export function YearSelect({ value, onChange, testId }) {
  return (
    <select value={value} onChange={(e) => onChange(Number(e.target.value))}
      className="px-3 py-1.5 rounded-lg border border-slate-300 text-sm focus:ring-2 focus:ring-teal-300" data-testid={testId}>
      {YEARS.map((y) => <option key={y} value={y}>{y}</option>)}
    </select>
  );
}

const KPI_TONES = {
  emerald: "border-emerald-200 bg-emerald-50 text-emerald-800",
  rose: "border-rose-200 bg-rose-50 text-rose-800",
  blue: "border-blue-200 bg-blue-50 text-blue-800",
  amber: "border-amber-200 bg-amber-50 text-amber-800",
  teal: "border-teal-200 bg-teal-50 text-teal-800",
  slate: "border-slate-200 bg-slate-50 text-slate-800",
};

export function KpiCard({ label, value, sub, tone = "teal", icon: Icon, testId }) {
  return (
    <div className={`rounded-xl border-2 p-4 ${KPI_TONES[tone]}`} data-testid={testId}>
      <div className="flex items-center justify-between mb-1">
        <span className="text-[10px] uppercase tracking-wider font-semibold opacity-70">{label}</span>
        {Icon && <Icon className="w-4 h-4 opacity-50" />}
      </div>
      <div className="text-lg font-bold font-mono">{value}</div>
      {sub && <div className="text-[10px] opacity-60 mt-0.5">{sub}</div>}
    </div>
  );
}

export function Field({ label, children, className = "" }) {
  return (
    <div className={className}>
      <label className="block text-[11px] font-semibold text-slate-600 mb-1">{label}</label>
      {children}
    </div>
  );
}

/** Image protégée (reçu) — charge le blob avec le Bearer admin. */
export function ReceiptThumb({ url, headers = authH(), className = "w-12 h-12" }) {
  const [src, setSrc] = useState("");
  useEffect(() => {
    if (!url) return undefined;
    let blobUrl = "";
    const base = (process.env.REACT_APP_BACKEND_URL || "");
    fetch(url.startsWith("http") ? url : `${base}${url}`, { headers })
      .then((r) => (r.ok ? r.blob() : null))
      .then((b) => { if (b) { blobUrl = URL.createObjectURL(b); setSrc(blobUrl); } })
      .catch(() => {});
    return () => { if (blobUrl) URL.revokeObjectURL(blobUrl); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);
  if (!url) return null;
  const isPdf = url.toLowerCase().endsWith(".pdf");
  return (
    <a href={src || "#"} target="_blank" rel="noopener noreferrer" title="Voir le reçu"
      className={`${className} rounded-lg border border-slate-200 bg-slate-50 flex items-center justify-center overflow-hidden flex-shrink-0`}>
      {isPdf || !src ? <span className="text-[9px] text-slate-500 font-semibold">{isPdf ? "PDF" : "…"}</span>
        : <img src={src} alt="Reçu" className="w-full h-full object-cover" />}
    </a>
  );
}
